module.exports = function getResource(label, vars = []) {
    const resources = {
        paymentErrorTitle: 'Erreur de paiement',
        paymentCancelledTitle: 'Paiement annulé',
        paymentCancelledMessage: 'Votre paiement PayPal a été annulé. Veuillez réessayer ou sélectionner un autre mode de paiement.',
        paymentErrorMessage: 'Une erreur s’est produite lors du traitement de votre paiement PayPal. Veuillez réessayer ou sélectionner un autre mode de paiement.',
        okButton: 'OK'
    };

    return resources[label];
};
